import { api } from '@/config/axios/index';

export default {
  fetchReports() {
    return api({
      method: 'GET',
      url: `${process.env.VUE_APP_API_ROUTE}/externalReport`,
    });
  },

  fetchPublicAnswers(query = '') {
    return api({
      method: 'GET',
      url: `${process.env.VUE_APP_API_ROUTE}/public-answer${query}`,
    });
  }
};
